import React from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
// COMPONENTS
import Row from 'components/common/Row';
import Col from 'components/common/Col';
import Icon from 'components/common/Icon';
import Title from 'components/text/Title';
// APOLLO
import removeUserFromTeam from 'ApolloClient/Mutations/removeUserFromTeam';
import { graphql } from 'react-apollo';
// LIB
import ErrorHelpers from 'lib/helpers/ErrorHelpers/index';
import getUsersFullName from 'lib/helpers/GeneralHelpers/getUsersFullName';
// ANTD
import message from 'antd/lib/message';
import 'antd/lib/message/style/css';
import Popconfirm from 'antd/lib/popconfirm';
import 'antd/lib/popconfirm/style/css';
import Avatar from 'antd/lib/avatar';
import 'antd/lib/avatar/style/css';

const ContentContainer = styled(Row)`
  border: 1px solid #d3d3d3;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 8px;
  padding: 8px;
  width: 75%;
`;

class TeamMemberRow extends React.PureComponent {
  onRemoveTeamMember = async userId => {
    let res;
    let variables = {
      orgId: this.props.organization._id,
      userId: this.props.user._id,
    };

    try {
      res = await this.props.removeUserFromTeam({ variables });
    } catch (err) {
      return ErrorHelpers.handleError(err);
    }

    message.success('User has been removed!');
    window.location.reload();
  };

  render() {
    const { user } = this.props;
    return (
      <ContentContainer justify="flex-start">
        <Col xs={2} onClick={() => this.props.history.push(`/admin/users/${user._id}`)} style={{ cursor: 'pointer' }}>
          <Avatar size="large" icon="user" />
        </Col>
        <Col xs={20} onClick={() => this.props.history.push(`/admin/users/${user._id}`)} style={{ cursor: 'pointer' }}>
          <strong>
            <Title>{getUsersFullName(user)}</Title>
          </strong>{' '}
          ({user.emails[0].address})
        </Col>
        <Col xs={2}>
          <Popconfirm
            placement="topLeft"
            title={`Remove ${getUsersFullName(user)}?`}
            onConfirm={this.onRemoveTeamMember}
            okText="Yes"
          >
            <Icon type="delete" style={{ color: '#D3D3D3', fontSize: 20, cursor: 'pointer' }} />
          </Popconfirm>
        </Col>
      </ContentContainer>
    );
  }
}

export default graphql(removeUserFromTeam, { name: 'removeUserFromTeam' })(withRouter(TeamMemberRow));



// WEBPACK FOOTER //
// ./src/routes/admin-organization-detail/TeamList/TeamMemberRow/index.js